export const FILE_UPLOAD_RESULT_KINDS = Object.freeze({
    STAGED: 'staged',
    COMPLETED: 'completed',
    UNCHANGED: 'unchanged',
    REJECTED: 'rejected',
    FAILED: 'failed',
});

export const FILE_RESULTS_THAT_CLEAR_SELECTION = new Set([
    FILE_UPLOAD_RESULT_KINDS.STAGED,
    FILE_UPLOAD_RESULT_KINDS.COMPLETED,
    FILE_UPLOAD_RESULT_KINDS.UNCHANGED,
]);
